module.exports = __webpack_public_path__ + "img/3.8c21d9e7.webp";